<template>
  <div class="form-item" :class="{ error: !!props.error }">
    <slot></slot>
    <div v-if="props.error" class="form-attribute-error">{{ props.error }}</div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  error?: string
}>()

</script>

<style>
.form-item {
  margin-bottom: 20px;
  position: relative;
}
.form-attribute-error {
  font-size: small;
  position: absolute;
  color: red;
  bottom: -15px;
  left: 5px;
}

.form-item.error .input__field {
  border-color: red;
}
</style>
